<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h3>Turnos Pendientes</h3>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :loading="cargando"
          :headers="headers"
          :items="turnos"
          :search="search"
          rows-per-page-text="Turnos por pagina"
          :rows-per-page-items="[5,10,25,{ text: 'Todos', value: -1 }]"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">
              {{ props.item.fecha | parseDate }}
              {{ props.item.hora }}
            </td>
            <td class="text-xs-left">
              {{ props.item.profesional }}
            </td>
            <td>
              <v-btn
                v-if="company.notaTurno && props.item.nota"
                icon
                class="primary"
                small
                @click="msg(props.item.nota)"
              >
                <v-icon>notes</v-icon>
              </v-btn>
              <v-btn
                v-if="props.item.videoConferencia"
                :href="jitsiUrl"
                target="_blank"
                icon
                class="primary"
                small
              >
                <v-icon>videocam</v-icon>
              </v-btn>
              <v-btn
                icon
                class="error"
                small
                @click="openCancelModal(props.item)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn
                icon
                class="primary"
                small
                @click="enviarMail()"
              >
                <v-icon>email</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { enviarMail } from '../../api/appointmentsEndpoints'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'AppointmentsTable',
  filters: {
    parseDate (val) {
      return moment(val).format('DD-MM-YYYY')
    }
  },
  props: {
    turnos: {
      type: Array,
      required: true
    },
    cargando: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      loading: false,
      search: '',
      headers: [
        { text: 'Fecha', value: 'hora' },
        { text: 'Profesional', value: 'profesional' },
        { text: '', value: null, sortable: false }
      ]
    }
  },
  computed: {
    ...mapState(['company']),
    ...mapGetters(['user']),
    jitsiUrl () {
      return 'https://meet.jit.si/' + this.user.id + '?lang=es#config.disableDeepLinking=true'
    }
  },
  methods: {
    openCancelModal (props) {
      this.$emit('openCancelModal', props)
    },
    msg (mensaje) {
      this.$root.$Msg(mensaje, 'Nota')
    },
    async enviarMail () {
      if (await this.$root.$confirm('Enviar Mail', 'Confirma el envío del Mail ?')) {
        this.loading = true
        const mailEnviado = await enviarMail(this.user.id)
        this.loading = false
        if (mailEnviado.respuesta === 'ERROR') {
          this.$createAlert({
            message: mailEnviado.mensaje,
            type: 'error',
            duration: 5000
          })
        } else {
          this.$createAlert({
            message: mailEnviado.mensaje,
            type: 'success',
            duration: 3000
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .small-width
    width: 50px
</style>
